import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/Explorer/NodeNameForm.tsx";
import "core-js/modules/es.string.trim.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { IconButton, ListItem, TextField, ListItemIcon } from '@mui/material';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import { useDocumentEventListener } from '@gmini/utils';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NodeNameForm = /*#__PURE__*/React.memo(function (_ref) {
  var icon = _ref.icon,
      disabled = _ref.disabled,
      submitDisabledProp = _ref.submitDisabled,
      _ref$defaultName = _ref.defaultName,
      defaultName = _ref$defaultName === void 0 ? '' : _ref$defaultName,
      pending = _ref.pending,
      onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      onClose = _ref.onClose,
      creationUpdate = _ref.creationUpdate;

  var _React$useState = React.useState(defaultName),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      name = _React$useState2[0],
      setName = _React$useState2[1];

  React.useEffect(function () {
    var createSubscription = creationUpdate === null || creationUpdate === void 0 ? void 0 : creationUpdate.watch(function () {
      if (name) {
        setName(defaultName);
      }
    });
    return function () {
      if (createSubscription) {
        createSubscription.unsubscribe();
      }
    };
  }, [creationUpdate, defaultName, name]);
  var handleChange = React.useCallback(function (event) {
    var value = event.currentTarget.value;
    setName(value);

    if (onChange) {
      onChange(event, value);
    }
  }, [onChange]);
  var submitDisabled = submitDisabledProp || !name || !!pending;
  var handleSubmit = React.useCallback(function (event) {
    event.preventDefault();

    if (onSubmit && !submitDisabled) {
      onSubmit(event, name);
    }
  }, [name, onSubmit, submitDisabled]);
  var ref = React.useRef(null);
  React.useEffect(function () {
    var _ref$current;

    return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
  }, []);
  var handleEscape = React.useCallback(function (e) {
    return e.key === 'Escape' && onClose && onClose();
  }, [onClose]);
  useDocumentEventListener('keydown', handleEscape);
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handleSubmit,
    children: /*#__PURE__*/_jsxs(ListItem, {
      ContainerComponent: "div",
      dense: true,
      button: true,
      disabled: !!pending,
      disableRipple: true // eslint-disable-next-line react/forbid-component-props
      ,
      style: {
        padding: '2px 6px'
      },
      children: [/*#__PURE__*/_jsx(ListItemIcon, {
        children: icon
      }), /*#__PURE__*/_jsx(TextField, {
        inputRef: ref,
        "data-test-id": "inputField",
        type: "text",
        size: "small",
        multiline: false,
        fullWidth: true,
        inputProps: {
          maxLength: 50,
          style: {
            fontSize: 14
          }
        },
        value: name,
        onChange: handleChange,
        variant: "standard"
      }), /*#__PURE__*/_jsxs(IconButton, {
        size: "small",
        type: "submit",
        "data-test-id": "submitName",
        edge: "end",
        disabled: submitDisabled || name.trim().length === 0,
        style: {
          padding: '3px',
          fontSize: '1.125rem'
        },
        children: [/*#__PURE__*/_jsx(CheckCircle, {}), submitDisabledProp && /*#__PURE__*/_jsx(IconSpinner, {
          size: 24
        })]
      }), /*#__PURE__*/_jsx(IconButton, {
        size: "small",
        "data-test-id": "cancel",
        edge: "end",
        onClick: onClose,
        disabled: disabled,
        style: {
          padding: '3px',
          fontSize: '1.125rem'
        },
        children: /*#__PURE__*/_jsx(Cancel, {})
      })]
    })
  });
});
NodeNameForm.displayName = 'NodeNameForm';
export var IconSpinner = styled(CircularProgress)({
  color: 'inherit',
  position: 'absolute'
});